import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import { logoutUser } from "../../store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"

// import components
import FullPageLoader from "components/Common/FullPageLoader"

const Logout = props => {
  const dispatch = useDispatch()

  const { loading } = useSelector(state => ({
    loading: state.Login.loading,
  }))

  useEffect(() => {
    dispatch(logoutUser(props.history))
  }, [dispatch])

  return (
    <React.Fragment>
      <FullPageLoader show={loading} message="Logging you out..." />
    </React.Fragment>
  )
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default withRouter(Logout)
